import { j as o } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as i } from "../../../node_modules/clsx/dist/clsx.m.js";
import d from "../Containers/Containers.js";
import c from "../Icon/Icon.js";
import r from "./FeaturedIcon.module.scss.js";
import f from "../../../node_modules/lodash/startCase.js";
const I = (t) => {
  const { iconName: e, variant: n = "tinted", colorType: s = "info", rounded: m = !0, size: a = "sm" } = t;
  return /* @__PURE__ */ o.jsx(
    d,
    {
      borderRadius: m ? "round" : "md",
      className: i(
        r.featuredIconContainer,
        r[`${n}${f(s)}`],
        r[a]
      ),
      children: /* @__PURE__ */ o.jsx(c, { name: e })
    }
  );
};
export {
  I as FeaturedIcon,
  I as default
};
//# sourceMappingURL=FeaturedIcon.js.map
